import * as React from "react";
import { NewPolygonDrawer } from "./NewPolygonDrawer";
import { handleIncrementPointsBy30 } from "../EditIgnoreZones/EditIgnoreZonesUtils/handleDecreasePointsBy30";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { ActuateButton } from "../../common/ActuateButton";
import { useNewIgnoreZonesStore } from "./newIgnoreZonesStore/newIgnoreZonesStore";

export const IgnoreZoneEditor = () => {
  const previewUrl = useNewIgnoreZonesStore((s) => s.previewUrl);
  const editorActive = useNewIgnoreZonesStore((s) => s.editSession != null);
  const shapeColor = useNewIgnoreZonesStore(
    (s) => s.editSession?.color ?? "#FF8400"
  );
  const adjustedDimensions = useNewIgnoreZonesStore((s) => s.adjustedDimensions);
  const setShapesArray = useNewIgnoreZonesStore((s) => s.setShapesArray);
  const saveEditSession = useNewIgnoreZonesStore((s) => s.saveEditSession);
  const cancelEditSession = useNewIgnoreZonesStore((s) => s.cancelEditSession);

  const [shapes, setShapes] = React.useState<number[][][]>(
    () => useNewIgnoreZonesStore.getState().shapesArray
  );
  const [iZpolygonPoints, setIZPolygonPoints] = React.useState<number[][]>([]);
  const [drawerKey, setDrawerKey] = React.useState(0);

  const initialCanvasShapesRef = React.useRef(
    handleIncrementPointsBy30(useNewIgnoreZonesStore.getState().shapesArray)
  );

  const imageWidth = adjustedDimensions.x;
  const imageHeight = adjustedDimensions.y;

  const setShapesFromDrawer = React.useCallback(
    (nextShapes: number[][][]) => {
      setShapes(nextShapes);
      setShapesArray(nextShapes);
    },
    [setShapesArray]
  );

  const handleClearAll = () => {
    setShapes([]);
    setShapesArray([]);
    setIZPolygonPoints([]);
    setDrawerKey((key) => key + 1);
  };

  const handleSave = () => {
    const updatedIZPolygonPoints = iZpolygonPoints.map((array: number[]) =>
      array.map((num) => num - 30)
    );
    const updatedShapes = [...shapes];
    if (updatedIZPolygonPoints.length >= 3) {
      updatedShapes.push(updatedIZPolygonPoints);
    }

    setShapesArray(updatedShapes.filter((shape) => shape.length >= 3));
    saveEditSession();
  };

  if (!editorActive || !previewUrl) {
    return null;
  }

  return (
    <div className="relative">
      <div
        style={{
          position: "relative",
          padding: "8px",
          borderRadius: "4px",
          backgroundColor: "white",
          display: "inline-block",
        }}
      >
        <div className="absolute">
          <NewPolygonDrawer
            key={drawerKey}
            initialPoints={[]}
            shapes={
              drawerKey === 0
                ? initialCanvasShapesRef.current
                : []
            }
            shapeColor={shapeColor}
            setShapes={setShapesFromDrawer}
            imageHeight={imageHeight}
            imageWidth={imageWidth}
            setIZPolygonPoints={setIZPolygonPoints}
          />
        </div>

        <div className="pt-[30px] pl-[30px]">
          <svg
            width={imageWidth}
            height={imageHeight}
            style={{
              backgroundImage: `url(${previewUrl})`,
              backgroundSize: `${imageWidth}px ${imageHeight}px`,
            }}
          >
            {shapes.map((shape, index) => (
              <polygon
                key={index}
                points={shape.map((point) => point.join(",")).join(" ")}
                fill={`${shapeColor}40`}
                stroke={shapeColor}
                strokeWidth={2}
              />
            ))}
          </svg>
        </div>

        <div className="pt-[40px] pl-[20px]">
          <OrangeTextButton
            onClick={handleClearAll}
            text="Clear All"
            disabled={false}
          />
        </div>
      </div>
      <div className="absolute -top-[37px] right-[200px] z-[10]">
        <OrangeTextButton onClick={cancelEditSession} text="Cancel" disabled={false} />
      </div>
      <div className="absolute -top-[37px] right-[40px] z-[10]">
        <ActuateButton onClick={handleSave} text="Save Edits" disabled={false} />
      </div>
    </div>
  );
};
